var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "empty-content-wrap" }, [
    _vm.data.img
      ? _c("img", {
          staticClass: "img-wrap",
          attrs: { src: _vm.data.img, alt: "" },
        })
      : _vm._e(),
    _vm.data.title
      ? _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.data.title))])
      : _vm._e(),
    _vm.data.desc
      ? _c("div", { staticClass: "desc" }, [_vm._v(_vm._s(_vm.data.desc))])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "btn-box" },
      [
        _vm._l(_vm.data.buttons, function (item, index) {
          return [
            !item.auth || _vm.authPromise(item.auth)
              ? _c(
                  "el-button",
                  {
                    key: index,
                    staticClass: "btn",
                    attrs: { type: item.type ? item.type : "primary" },
                    on: { click: item.click },
                  },
                  [_vm._v(" " + _vm._s(item.text) + " ")]
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }